import { identity, isEmpty, prop, propEq } from 'ramda'
import { isBoolean } from '@btime/helpers'
import React from 'react'

import { Col, Grid } from '../structure/Grid'
import { useActiveTab, useSetTab, useTabOptions } from './TabsContext'
import Line from '../helpers/Line'
import Link from '../actions/Link'
import Separator from '../helpers/Separator'
import Text from '../presentation/Text'

export const TabsMenuItem = ({ option, active, t, onClick, ...props }) => {
  t = t || identity
  const activeTab = useActiveTab()
  const setTab = useSetTab()

  active = isBoolean(active)
    ? active
    : isEmpty(activeTab)
    ? option.active
    : propEq('name', prop('name', option), activeTab)
  const label = option.label || option.name

  const handleOnClick = () => {
    if (onClick) onClick(option)
    if (option.onClick) option.onClick(option)
    if (setTab) setTab(option)
  }

  if (option?.notShow) return false

  return (
    <Link onClick={handleOnClick}>
      <Text bold color={active ? 'primary' : 'light5'} {...props}>
        {t(label, label)}
      </Text>
      <Separator weight={1} />
      <Line color={active ? 'primary' : 'transparent'} height={0.25} />
    </Link>
  )
}

const TabsMenu = ({ options, justify = 'center', ...props }) => {
  const optionsFromContext = useTabOptions()

  options = options || optionsFromContext

  return (
    <Grid justify={justify} align="flex-end" gap={2} {...props}>
      {options?.map(option => {
        return (
          <Col key={option.name}>
            <TabsMenuItem option={option} {...props} />
          </Col>
        )
      })}
    </Grid>
  )
}

export default TabsMenu
